import React from 'react'
import Header from '../Components/Header';
import Divider from './../Images/divider.png';
import GroupImg from './../Images/group-img.png';
import DotsTheme from './../Images/dots-theme.png';
import BigImg from './../Images/big-img.png';
import SmallImg from './../Images/small-img.png';
import Footer from '../Components/Footer';
import frame from './../Images/frame.png';

const ResidentialLand = () => {
    return (
        <>
            <Header />

            <div className="pt-150">
                <div className="container mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Residential Land Development</h1>
                        <p>VISTAPLOTS provides you with the sustainable lifestyle amenities based Residential Plots which has been analysed by the in-house experts and our legal team. Every aspect of selecting the Land for the Residential Plot development has gone through the right approach of number of test parameters which makes you very comfortable to encash your Investments to buy the Plots directly from VISTAPLOTS.  </p>

                    </div>
                </div>
                <div className="dots-rel  mb-200">
                <div className="dots-theme">
                            <img src={DotsTheme} alt="" />
                        </div>
                        <div className="dots-theme-2">
                            <img src={DotsTheme} alt="" />
                        </div>
                    <div className="container position-rel">
                        
                        <div className="about-img-large mb-4">
                            <img src={GroupImg} alt="" />
                        </div>
                        <div className="about-img-small mb-4">
                            <img src={GroupImg} alt="" />
                        </div>
                        

                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3">
                    






                        <p> We, At VISTAPLOTS build the blueprint which has direct connections with the nature and environment that helps to breath the better air through a lot of greenery in and around your Residential Plots. We Introduce the Residential Plots which are quite connected to the Technology Hubs, Schools, Hospitals, and the Shopping Complex. </p><p></p><br />
                        <p>We, At VISTAPLOTS build the blueprint which has direct connections with the nature and environment that helps to breath the better air through a lot of greenery in and around your Residential Plots. We Introduce the Residential Plots which are quite connected to the Technology Hubs, Schools, Hospitals, and the Shopping Complex.</p><p></p><br />
                        <p>We, At VISTAPLOTS create the open spaces with trees and gardens to ensure the clean air in our Residential Plot areas. We have planted more than 1000 Plus Saplings in our area around the Residential Plots. We are currently working on the Residential Plots in and around Bangalore. We are also expanding our user base across the different Tier1 cities of India. 
                        </p><p></p><br />
                        <p>We don’t like wasting the water. We ensure that the water from rainfall is rightly harvested through the Water Harvesting Process which can be used for the recycling and reuse actives. We are the Leading Trustworthy Residential Plot developers in India. We provide you with the World Class Standards and worth for the money you Invest in buying the plots. </p>

                        <p>VISTAPLOTS team works with the principles of the Excellence. Our goal is to provide the customer with the quality services and support for the Investments. We offer you the best plot what your Best Residential Home Prefers. 
                        </p><p></p><br />
                        <p>Buying a Residential Plot in Bangalore is everyone’s dream. We only sell the Residential Plots in Bangalore which are approved by BDA (Bangalore Development Authority), BBMP (Bruhat Bengaluru Mahanagara Palike), BMRDA (Bangalore Metropolitan Region Development Authority), DTCP (Directorate of Town & Country Planning) and RERA (Real Estate Regulations Authority).
                        </p>

                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Why should you buy a Residential Plot this year?</h1>
                        


                        <p>Land and Plots are usually having the higher appreciation value compared to any other Investments. The Land or Plots can be easier to sell, and the exit is also quite easier. A Plot Size of 1200 Sq. Ft, 1500 Sq. Ft, 2400 Sq. Ft, and more are quite very easy to sell off within 5 years of time having more than 100% of the appreciation value compared to any other Investments. </p><p></p><br />
                        <p>The Developed BDA Plots in Bangalore have the best capital appreciation as many corporate companies are choosing Bangalore as the primary investment location to expand their companies. With the Career Options and Start-up Companies getting expanded mainly in the IT hub Bangalore, Several people are moving into Bangalore this year. This Improvement have given more space for the Real Estate Expansion in Bangalore. </p><p></p><br />
                        <p>
Whether you are purchasing a Residential Plot for yourself In Bangalore, or you are purchasing a Residential Plot to construct to rent it out, Buying a Plot in Bangalore has always a good appreciation value. Buying Plot and Selling within 5 Years can give you a minimum of 100% profit. The Demand for the Real Estate has been growing more as the IT hub in the Bangalore along with the Start-up companies keep expanding. So, Investing in the Residential Plot in Bangalore is always considered to be the safest and wisest option. </p>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Appreciation of the Residential Plot Land</h1>
                        <p>The Appreciation of the Land Value is increasing exponentially. The Land Value Appreciation is greatly proportionate to the location of the Residential Plot. The Nearby availability of the Transport, Schools, Healthcare, Retail Showrooms are an added advantage which can help to appreciate the Land value. 
Buy the Residential Plot with VISTAPLOTS.
 </p>
                    </div>
                </div>
                
            </div>


           

            <Footer />
        </>
    )
}

export default ResidentialLand